import React from 'react';
import Project1 from './Project1';
import Project2 from './Project2';
import Project3 from './Project3';
import Project4 from './Project4';
import Project5 from './Project5';
import Project6 from './Project6';
const Project=()=>{
    return(
        <div>
          
          <Project1/>
        <hr/>
        <hr/>
          <Project2/>
          <hr/>
            <Project3/>
             <hr/>
            <Project4/>
             <hr/>
            <Project5/>
            <hr/>
            <Project6/>
        </div>
    )

}
export default Project